import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  type: 'Sub Branch Channel Opps',
  currentYear: '',
  currentQuarter: '',
  selectedYear: '',
  selectedQuarter: '',
  compareSelectedYear: '',
  compareSelectedQuarter: '',
  subDashChannelOppsRange: {
    start_week: null,
    start_year: null,
    end_week: null,
    end_year: null,
  },
  subDashCompareChannelOppsRange: {
    start_week: null,
    start_year: null,
    end_week: null,
    end_year: null,
  },
};

const subBranchDashOppsByChannelSlice = createSlice({
  name: 'subBranchDashOppsByChannel',
  initialState,
  reducers: {
    setCurrentQuarter: (state, action) => {
      return { ...state, currentQuarter: action.payload };
    },
    setCurrentYear: (state, action) => {
      return { ...state, currentYear: action.payload };
    },
    setSelectedQuarter: (state, action) => {
      return { ...state, selectedQuarter: action.payload };
    },
    setSelectedYear: (state, action) => {
      return { ...state, selectedYear: action.payload };
    },
    setCompareSelectedYear: (state, action) => {
      return { ...state, compareSelectedYear: action.payload };
    },
    setCompareSelectedQuarter: (state, action) => {
      return { ...state, compareSelectedQuarter: action.payload };
    },
    setSubDashChannelOppsRange: (state, action) => {
      return { ...state, subDashChannelOppsRange: action.payload };
    },
    setSubDashCompareChannelOppsRange: (state, action) => {
      return { ...state, subDashCompareChannelOppsRange: action.payload };
    },
  },
});

export const subBranchDashOppsByChannelActions = subBranchDashOppsByChannelSlice.actions;

export default subBranchDashOppsByChannelSlice.reducer;
